"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated use DialogWidth instead
 */
var CaptionedPopupStyle;
(function (CaptionedPopupStyle) {
    CaptionedPopupStyle["MEDIUM_WIDTH"] = "dialog-width-medium";
    CaptionedPopupStyle["FULL_WIDTH"] = "dialog-width-full";
    CaptionedPopupStyle["AUTO_WIDTH"] = "";
})(CaptionedPopupStyle || (CaptionedPopupStyle = {}));
exports.default = CaptionedPopupStyle;
//# sourceMappingURL=CaptionedPopupStyle.js.map